import { Button, Label, TableItem } from 'components/atoms';
import { Table } from 'components/organisms';
import { useInfiniteTable } from 'hooks/useInfiniteTable';
import { useCustomParamId } from 'hooks/useParamId';
import { t } from 'i18next';
import {
  PiEye,
  PiNavigationArrow,
  PiThumbsDown,
  PiThumbsUp,
} from 'react-icons/pi';
import { useGetContractVideos } from 'services/contract/products';

const ContractVideosTab = () => {
  const contractId = useCustomParamId('contractId');

  const videos = useGetContractVideos(contractId);

  const tableProps = useInfiniteTable(videos);

  const navigateToYtVideo = (videoId: string) => {
    const targetPath = `https://www.youtube.com/watch?v=${videoId}`;
    window.open(targetPath, '_blank');
  };

  const goToTrack = (id: string) => window.open(`/track/${id}`, '_blank');

  return (
    <Table
      id='contract-videos'
      size='compact'
      {...tableProps}
      data={{
        nodes: tableProps.data.nodes.map(p => ({
          ...p,
          id: `/channel/${p.channelId}/channel-video/${p.id}/contracts`,
        })),
      }}
      columns={[
        {
          label: t('input.label.title'),
          renderCell: ({ videoTitle, videoImageLink }) => (
            <TableItem>
              <div className='flex flex-row items-center gap-4'>
                <img src={videoImageLink} alt='' style={{ width: '80px' }} />
                <TableItem.Text text={videoTitle} />
              </div>
            </TableItem>
          ),
          resize: false,
        },

        {
          label: '',
          renderCell: ({
            externalVideoId,
            dislikesCount,
            likesCount,
            views,
          }) => (
            <TableItem justifyPosition='end'>
              <div className='flex gap-2 items-center'>
                <Label
                  size='compact'
                  withText
                  style={{ minWidth: 120 }}
                  color='blue'>
                  <PiEye /> {views.toLocaleString()}
                </Label>
                <Label size='compact' withText style={{ minWidth: 100 }}>
                  <PiThumbsUp /> {likesCount.toLocaleString()}
                </Label>
                {!!dislikesCount && (
                  <Label size='compact' withText style={{ minWidth: 100 }}>
                    <PiThumbsDown /> {dislikesCount.toLocaleString()}
                  </Label>
                )}
                <Button
                  type='button'
                  isClear
                  onlyIcon
                  onClick={() => navigateToYtVideo(externalVideoId)}>
                  <Button.Icon
                    icon={<PiNavigationArrow transform='scale(-1,1)' />}
                  />
                </Button>
              </div>
            </TableItem>
          ),
        },

        // {
        //   label: '',
        //   renderCell: ({ externalVideoId }) => (
        //     <TableItem>
        //       <TableItem.Text isSupplementary text={externalVideoId} />
        //     </TableItem>
        //   ),
        //   resize: true,
        // },
      ]}
    />
  );
};

export default ContractVideosTab;
